/*
 * @Date: 2022-09-07 10:27:11
 * @LastEditors: guantingting
 * @LastEditTime: 2022-09-07 10:39:23
 */
export default [
  {
    path: '/rent/v2/equity-package/my-equity',
    name: 'myEquity',
    component: () => import('@/pages/equityPackage/myEquity'),
    meta: { title: '我的权益包', requireAuth: true },
  },
  {
    path: '/rent/v2/equity-package/equity-record',
    name: 'equityRecord',
    component: () => import('@/pages/equityPackage/equityRecord'),
    meta: { title: '权益记录', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/equityPackage/equityPackage.js